import { render } from "./WhatsAppMetaConfirmDialog.vue?vue&type=template&id=fb220ce8&ts=true"
import script from "./WhatsAppMetaConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/WhatsAppMetaConfirmDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb220ce8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb220ce8', __exports__)) {
    api.reload('fb220ce8', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaConfirmDialog.vue?vue&type=template&id=fb220ce8&ts=true", () => {
    api.rerender('fb220ce8', render)
  })

}


export default __exports__